export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-brush/src/constant.js
// module id = 334
// module chunks = 4